const WidgetServiceFactory = ({ HTTPBase }) => {
    return {
        getWidgetList: (userId) => {
            const ns = 'dashboard';
            return HTTPBase.get(`/user-settings/${userId}/${ns}`).then((res) => res.data);
        },
        updateWidgetList: (userId, widgetList) => {
            const ns = `dashboard`;
            return HTTPBase.put(`/user-settings/${userId}/${ns}`, widgetList).then((res) => res.data);
        },
    };
};
export default WidgetServiceFactory;
//# sourceMappingURL=widget.api.js.map